export default function About() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-lg p-6 md:p-10 border border-background-200/60">
          <div className="text-center mb-5 md:mb-6">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              关于我们
            </h2>
            <p className="text-sm text-foreground-500">星球漫画 · 探索宇宙故事的无限可能</p>
          </div>
          <div className="max-w-2xl mx-auto">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
              <strong className="text-foreground-900">星球漫画</strong> 是一个专注于星际漫画、科幻漫画和宇宙漫画的免费在线阅读平台。
              我们致力于为每一位科幻爱好者提供最优质、最全面的漫画阅读体验。从星球大战的宏大史诗到星际冒险的个人传奇，
              从硬核科幻的技术推演到轻松有趣的太空日常，这里总有一部作品能触动你的宇宙情怀。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
              我们的编辑团队每日精选优质内容，通过人气榜单、焦点专题和读者热评为您推荐好看的科幻漫画。
              独创的下拉式阅读技术让您在浏览长篇漫画时获得丝滑流畅的沉浸体验，配合高清画质优化，每一格画面都清晰动人。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              自上线以来，星球漫画已累计服务超过百万星际漫画爱好者，收录数万部优质作品。
              我们持续与优秀漫画创作者合作，不断扩充内容库，努力打造国内最好的免费在线漫画网站。
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mt-6 md:mt-8 max-w-2xl mx-auto">
            {[
              { value: '100 万+', label: '读者用户' },
              { value: '3 万+', label: '漫画作品' },
              { value: '每日更新', label: '更新频率' },
              { value: '99.9%', label: '服务可用率' },
            ].map((stat) => (
              <div key={stat.label} className="text-center bg-background-50 rounded-lg p-3 md:p-4 border border-background-200/60">
                <div className="text-lg md:text-xl font-heading font-bold text-primary-600 mb-0.5 whitespace-nowrap">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-500 whitespace-nowrap">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}